export class RiverAudio {
  constructor() {
    this.context = null;
    this.master = null;
    this.started = false;
    this.muted = false;
    this.soundtrack = 'off';
  }

  async start() {
    if (this.started) {
      await this.context?.resume();
      return;
    }
    const AudioContext = globalThis.AudioContext || globalThis.webkitAudioContext;
    if (!AudioContext) return;
    this.context = new AudioContext();
    this.master = this.context.createGain();
    this.master.gain.value = this.muted ? 0 : 0.72;
    this.master.connect(this.context.destination);
    this.started = true;
  }

  setMuted(muted) {
    this.muted = Boolean(muted);
    if (this.master && this.context) {
      this.master.gain.cancelScheduledValues(this.context.currentTime);
      this.master.gain.linearRampToValueAtTime(this.muted ? 0 : 0.72, this.context.currentTime + 0.08);
    }
  }

  // Retain the old caller API so a saved soundtrack preference cannot restart
  // continuous music or ambience after an upgrade.
  async setSoundtrack() {
    this.soundtrack = 'off';
  }

  tone({ frequency = 300, duration = 0.08, gain = 0.03, type = 'sine', slide = 0 } = {}) {
    if (!this.started || this.muted || this.context.state !== 'running') return;
    const oscillator = this.context.createOscillator();
    const envelope = this.context.createGain();
    const now = this.context.currentTime;
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, now);
    oscillator.frequency.exponentialRampToValueAtTime(Math.max(30, frequency + slide), now + duration);
    envelope.gain.setValueAtTime(0.0001, now);
    envelope.gain.exponentialRampToValueAtTime(gain, now + 0.01);
    envelope.gain.exponentialRampToValueAtTime(0.0001, now + duration);
    oscillator.connect(envelope).connect(this.master);
    oscillator.start(now);
    oscillator.stop(now + duration + 0.02);
  }

  coin() {
    this.tone({ frequency: 920, duration: 0.08, gain: 0.032, type: 'triangle', slide: 180 });
    setTimeout(() => this.tone({ frequency: 1240, duration: 0.06, gain: 0.018, type: 'sine', slide: -80 }), 48);
  }

  purchase() {
    this.tone({ frequency: 330, duration: 0.12, gain: 0.03, type: 'triangle', slide: -100 });
  }

  hammer() {
    this.tone({ frequency: 150, duration: 0.055, gain: 0.026, type: 'square', slide: -70 });
  }

  // Passing river traffic is visual ambience only. Action sounds remain short.
  whistle() {}

  openingChime() {
    this.tone({ frequency: 392, duration: .26, gain: .07, type: 'triangle', slide: 12 });
    setTimeout(() => this.tone({ frequency: 523.25, duration: .42, gain: .065, type: 'triangle', slide: 10 }), 180);
  }
}
